import { Input, Button, Switch, Form, Upload, Select, Radio, Checkbox, RadioChangeEvent } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import React, { ReactNode, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import { addConnTypeConnSize, modifyConnTypeConnSize } from './fittingTypeSlice';
import type { UploadProps } from 'antd';
import { useSelector } from 'react-redux';
import { AppState } from '../../redux/store/rootReducer';
import { CheckboxChangeEvent } from 'antd/es/checkbox';



export default function AddConnTypeConnSizePage({ connTypeId }: any): JSX.Element {

    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const { setModelChange1, setEditCS } = React.useContext(CommonContext) as CommonContextType;
    const [conn_size_array, setConnSizeArray] = useState([{}]);
    const [measure_unit_arr, setMeasureUnit] = useState<any>([{}]);
    const [rad_value, setRadValue] = useState();
    const [fileList, setFileList] = useState<any>();
    const [file, setFile] = useState<any>()
    const connSizes = useSelector((state: AppState) => state.FittingSizes);
    const connTypes = useSelector((state: AppState) => state.FittingTypes);

    useEffect(() => {

        const arr = connTypes.MeasuringUnit.map((el: any) => ({ label: el.unit, value: el.id }))
        setMeasureUnit(arr)
    }, [connSizes]);

    React.useEffect(() => {
        if (connTypeId[1]?.id) {
            aa(connTypeId[1]?.measure_unit?.id)
            // if (editCategory?.id) 
            // setIsDisabled(editCategory.disabled)
            setFileList([
                {
                    name: connTypeId[1]?.conn_type_size_img_url?.split('/').pop(),
                    url: process.env.REACT_APP_AZURE_BLOB_STORAGE_API + connTypeId[1]?.conn_type_size_img_url,
                }
            ])
            setFile(null)
            form.setFieldsValue(Object.assign({ measure_units: connTypeId[1]?.measure_unit?.id }, { conn_sizes: connTypeId[1]?.conn_size?.id }, connTypeId[1]))/* { body_sizes: connSizeId[1]?.body_size?.id  },  */

        } else {
            setFileList(null);
            setFile(null);

            form.resetFields();
            form.setFieldsValue(null)
        }
    }, [connTypeId[1], form]);

    const onFinish = (values: any) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('conn_type', connTypeId[0])
        formData.append('measure_unit', values.measure_units)
        formData.append('conn_size', values.conn_sizes)

        if (connTypeId[1]?.id) {
            formData.append('img_url_old', connTypeId[1]?.conn_type_size_img_url)
            // formData.append('updated_datetime', new Date().toLocaleString() + "");
            dispatch(modifyConnTypeConnSize(formData, connTypeId[1]?.id))
        } else {
            dispatch(addConnTypeConnSize(formData));
        }



        setFileList(null);
        setFile(null);
        setModelChange1(false)
        form.resetFields();
        setEditCS(null)
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    const handleChange: UploadProps["onChange"] = ({ fileList: newFileList }) => {
        newFileList[0].status = 'done'
        setFile(newFileList[0].originFileObj)
        setFileList(newFileList);
    }

    const aa = (e: any) => {
        form.setFieldsValue({ conn_sizes: '' });
        if (connSizes.FittingSize.length > 0) {
            let arr1: any = []
            connSizes.FittingSize.map((el: any) => {/*  */
                if (el.measure_unit.id == e) {
                    arr1.push({ value: el.id, label: el.size_name })
                }
            })
            setConnSizeArray(arr1);
        }
    };

    const onChangeSelect = (e: RadioChangeEvent) => {
        form.setFieldsValue({ conn_sizes: '' });
        if (connSizes.FittingSize.length > 0) {
            let arr1: any = []
            connSizes.FittingSize.map((el: any) => {/*  */
                if (el.measure_unit.id == e.target.value) {
                    arr1.push({ value: el.id, label: el.size_name })
                }
            })
            setConnSizeArray(arr1);
        }
    };
    const props = {
        showUploadList: {
            showRemoveIcon: false,
            showPreviewIcon: false,
        },
    }
    return (
        <Form
            form={form}
            layout={'vertical'}
            initialValues={{
                status: "Released"
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
        >

            <Form.Item>
                <Upload.Dragger
                    {...props}
                    listType="picture-card"
                    fileList={fileList}
                    onChange={handleChange}
                    maxCount={1}
                    accept="image/*"
                >
                    <div>
                        <p className="ant-upload-drag-icon">
                            <InboxOutlined />
                        </p>
                        <p className="ant-upload-text">Drag file to upload</p> Or Select file from your PC
                    </div>
                </Upload.Dragger>
            </Form.Item>

            <Form.Item
                name='measure_units'>
                <Radio.Group options={measure_unit_arr} onChange={onChangeSelect} />
            </Form.Item>

            <Form.Item
                name='conn_sizes' label="Connection Size"
                rules={[
                    {
                        required: true,
                        message: 'Please select Connection size',
                    },
                ]}>
                <Select
                    placeholder="Select"
                    options={conn_size_array}>
                </Select>
            </Form.Item>


            <Form.Item>
                <Button className='submit-button' type="primary" htmlType="submit" >{connTypeId[1]?.id ? 'Update' : 'Create'}</Button>
            </Form.Item>
        </Form>
    )

}